module.exports = __webpack_public_path__ + "img/rha_two.af420bbe.png";